var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0249 11.7087C42.5491 12.3796 40.9582 12.8204 39.3099 13.0312C40.9966 12.0154 42.2999 10.4054 42.9132 8.46956C41.3224 9.4279 39.5591 10.0987 37.6999 10.4821C36.1857 8.83373 34.0582 7.8754 31.6432 7.8754C27.1391 7.8754 23.4591 11.5554 23.4591 16.0979C23.4591 16.7496 23.5357 17.3821 23.6699 17.9762C16.8466 17.6312 10.7707 14.3537 6.72656 9.38956C6.01739 10.5971 5.61489 12.0154 5.61489 13.5104C5.61489 16.3662 7.05239 18.8962 9.27572 20.3337C7.91489 20.3337 6.64989 19.9504 5.53822 19.3754V19.4329C5.53822 23.4196 8.37489 26.7546 12.1316 27.5021C10.9254 27.8321 9.65924 27.8781 8.43239 27.6362C8.95297 29.2701 9.9725 30.6998 11.3477 31.7243C12.7228 32.7488 14.3845 33.3166 16.0991 33.3479C13.1927 35.6487 9.59005 36.8924 5.88322 36.8746C5.23156 36.8746 4.57989 36.8362 3.92822 36.7596C7.56989 39.0979 11.9016 40.4587 16.5399 40.4587C31.6432 40.4587 39.9424 27.9237 39.9424 17.0562C39.9424 16.6921 39.9424 16.3471 39.9232 15.9829C41.5332 14.8329 42.9132 13.3762 44.0249 11.7087Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiTwitter);
export default __webpack_public_path__ + "static/media/mdi_twitter.1d99cecc1fe19c807195638689ae114b.svg";
export { ForwardRef as ReactComponent };